import React, { useState } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Text from '../Text/Text'
import checkIsDesktop from '../../../hooks/checkIsDesktop'

import styles from './sidebar.module.scss'

const MenuWithChildren = ({
  currentPath,
  history,
  menu,
  handleButtonExpand
}) => {
  const [show, setShow] = useState(false)
  const collapseMenu = classnames(styles.collapse, {
    [styles.show]: show || currentPath.includes('dashboard')
  })

  const isDesktop = checkIsDesktop()

  const handleCollapse = () => {
    if (isDesktop) handleButtonExpand()
    setShow(!show)
  }

  return (
    <li className={styles.menuWithChild}>
      <button type="button" onClick={handleCollapse}>
        {menu.icon}
        <Text
          className={styles.menuLabel}
          size="xs"
          color="gray"
          value={menu.name}
          fontWeight="300"
          font="custom"
        />
      </button>
      <div className={collapseMenu}>
        <ul>
          {menu.children.map((child) => {
            const isChildActive = child.route === currentPath

            return (
              <li
                key={child.optionId}
                onClick={() => history.push(child.route)}
                className={isChildActive ? styles.active : undefined}
              >
                <Text
                  className={styles.menuLabel}
                  size="xs"
                  color="gray"
                  value={child.name}
                  fontWeight="300"
                  font="custom"
                />
              </li>
            )
          })}
        </ul>
      </div>
    </li>
  )
}

MenuWithChildren.propTypes = {
  menu: PropTypes.shape({
    icon: PropTypes.element,
    name: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        route: PropTypes.string,
        optionId: PropTypes.number,
        name: PropTypes.string
      })
    )
  }).isRequired,
  currentPath: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  handleButtonExpand: PropTypes.func.isRequired
}

export default MenuWithChildren
